// Android WebView Bridge
import api from '../services/api';

// Android 앱과의 통신을 위한 유틸리티
export const androidBridge = {
  // Android 앱인지 확인
  isAndroidApp() {
    return typeof window.Android !== 'undefined';
  },

  // 인증 토큰 저장 (Android 앱에 전달)
  saveAuthToken(token) {
    if (this.isAndroidApp() && window.Android.saveAuthToken) {
      window.Android.saveAuthToken(token);
    }
  },

  // 인증 토큰 삭제
  clearAuthToken() {
    if (this.isAndroidApp() && window.Android.clearAuthToken) {
      window.Android.clearAuthToken();
    }
  },

  // 토스트 메시지 표시
  showToast(message) {
    if (this.isAndroidApp() && window.Android.showToast) {
      window.Android.showToast(message);
    }
  },

  // 디바이스 정보 가져오기
  getDeviceInfo() {
    if (this.isAndroidApp() && window.Android.getDeviceInfo) {
      try {
        return JSON.parse(window.Android.getDeviceInfo());
      } catch (e) {
        console.error('Failed to parse device info:', e);
      }
    }
    return null;
  }
};

// FCM 토큰 등록 함수 (Android 앱에서 호출)
window.registerFCMToken = async (token) => {
  console.log('Registering FCM token:', token);
  
  try {
    // localStorage에서 인증 토큰 확인
    const authToken = localStorage.getItem('token');
    if (!authToken) {
      console.log('No auth token found, waiting for login...');
      return;
    }

    // 디바이스 정보 가져오기
    const deviceInfo = androidBridge.getDeviceInfo() || {};
    
    // FCM 토큰 등록 API 호출
    const response = await api.post('/fcm/register', {
      device_token: token,
      device_type: 'android',
      device_name: deviceInfo.model || 'Unknown',
      device_model: deviceInfo.manufacturer || 'Unknown',
      app_version: deviceInfo.appVersion || '1.0.0'
    });

    console.log('FCM token registered successfully:', response.data);
    androidBridge.showToast('푸시 알림이 활성화되었습니다.');
  } catch (error) {
    console.error('Failed to register FCM token:', error);
  }
};

// 로그인 성공 시 처리
export const handleLoginSuccess = (token, user) => {
  // localStorage에 토큰 저장
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  
  // Android 앱에 토큰 전달
  androidBridge.saveAuthToken(token);
  
  // FCM 토큰이 있으면 재등록 시도
  if (window.pendingFCMToken) {
    window.registerFCMToken(window.pendingFCMToken);
    window.pendingFCMToken = null;
  }
};

// 로그아웃 시 처리
export const handleLogout = () => {
  // localStorage 정리
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // Android 앱에 알림
  androidBridge.clearAuthToken();
};

// 로그인 상태 변화 감지
window.addEventListener('storage', (e) => {
  if (e.key === 'token') {
    if (e.newValue) {
      // 로그인됨
      androidBridge.saveAuthToken(e.newValue);
      
      // 대기 중인 FCM 토큰이 있으면 등록
      if (window.pendingFCMToken) {
        window.registerFCMToken(window.pendingFCMToken);
        window.pendingFCMToken = null;
      }
    } else {
      // 로그아웃됨
      androidBridge.clearAuthToken();
    }
  }
});